import { ErrorHandler, provideZoneChangeDetection } from '@angular/core';
/// <reference types="@angular/localize" />

import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import { provideCharts, withDefaultRegisterables } from 'ng2-charts';
import { GlobalErrorHandlerService } from './app/core/services/global-error-handler.service';

bootstrapApplication(AppComponent, {
  providers: [provideZoneChangeDetection(), ...appConfig.providers, provideCharts(withDefaultRegisterables())
    , {
    provide: ErrorHandler,
    useClass: GlobalErrorHandlerService
  }
  ],
}).catch((err) => console.error(err));
